// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".b52a0c6c55ce4e22151ad3cf6f08078f.js";
};